// extracted by mini-css-extract-plugin
module.exports = {"SArticleImage":"Information_SArticleImage__UUJm_","SIngress":"Information_SIngress__cAll_","STextContainer":"Information_STextContainer__iR1cX"};